<template><div class="contents">
    <select-menu
        v-model="locale"
        :text="['Deutsch']" :values="['de']"
        class="mb-1">
    </select-menu>
</div>
</template>

<script>
import SelectMenu from "../UI/SelectMenu.vue";

export default {
    name: "LanguageSelect",

    components: {
        SelectMenu
    },

    inject: ['user'],

    data: (vm) => ({
        locale: vm.user.language
    }),

    watch: {
        locale(value) {
            this.$http.put(`/admin/users/${this.user.id}`, {
                language: value,
            }).then(() => {
                this.$root.$i18n.locale = value;
                this.user.language = value;
            }).catch(error => {
                this.$root.$emit('error', error);
            });
        },
    },
}
</script>

<style scoped>

</style>
